import { createSlice } from '@reduxjs/toolkit'

export const onLoadOrganizationsReducer = (state, { payload }) => {
  const { organizations } = payload

  const newState = {
    ...state,
    organizations
  }
  return newState
}

export const onSaveOrganizationReducer = (state, { payload }) => {
  const { organization } = payload

  const newState = {
    ...state,
    organization
  }
  return newState
}

const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    organizations: [],
    organization: {
      id: null,
      littlebitsId: null,
      slug: null,
      street1: null,
      name: null,
      description: null,
      city: null,
      state: null,
      country: null,
      postalCode: null
    }
  },
  reducers: {
    onLoadOrganizations: onLoadOrganizationsReducer,
    onSaveOrganization: onSaveOrganizationReducer
  }
})

const { actions, reducer } = organizationSlice

export const {
  onLoadOrganizations,
  onSaveOrganization
} = actions

export default reducer
